/* eslint-disable react-hooks/exhaustive-deps */
import { Dialog } from "primereact/dialog";
import React, { useState, useEffect } from "react";
import Form from "../../../shared/forms/Form";
import Field from "../../../shared/forms/Field";
import FormCalendar from "../../../shared/forms/FormFields/FormCalendar";
import FormInputNumber from "../../../shared/forms/FormFields/FormInputNumber";
import useApiIncidencia from "../../../api/administracion/useApiIncidencia";
import useForm from "../../../shared/forms/useForm";
import { Button } from "primereact/button";
import { serialize } from "object-to-formdata";
import produce from "immer";
import FormTextArea from "../../../shared/forms/FormFields/FormTextArea";

const initialValues = {
    fechaInicio: new Date()
};

const Cobro = ({ cargo, incidenciaId, visible, onClose, onSaved }) => {

    const api = useApiIncidencia();
    const [submitted, setSubmitted] = useState(false);

    const {
        values: cobro,
        setValues,
        onChange,
        onValidate,
        isValid
    } = useForm(initialValues);

    useEffect(() => {
        if (!cargo) return;

        const newValue = produce(cargo, draft => {
            draft.saldoAnterior = draft.costo;
            draft.saldo = draft.costo;
            draft.exhibiciones = 1;
            draft.descuento = 0;
            draft.parcialidad = draft.costo;
        });

        setValues(newValue);
    }, [cargo]);

   const onSend = async () => {
    setSubmitted(true);
    if (!isValid) return;

    const payload = {
        IncidenciaId: incidenciaId,
        CargoId: cargo?.id,    // <<--- AÑADE ESTO
        Exhibiciones: cobro.exhibiciones,
        FechaInicio: cobro.fechaInicio,
        Descuento: cobro.descuento,
        Comentarios: cobro.Comentarios,
        Saldo: cobro.saldo
    };

    const formData = serialize(payload, {
        indices: true,
        dotsForObjectNotation: true
    });

    await api.enviarCargo(formData);
    onSaved();
};

    const renderFooterModal = () => (
        <div className="p-1">
            <Button label="Cancelar" onClick={onClose} className="p-button-outlined" />
            <Button label="Enviar Cobro" onClick={onSend} type="button" />
        </div>
    );

    return (
        <Dialog header="Cobrar" visible={visible} style={{ width: '50%' }}
            onHide={onClose} footer={renderFooterModal}>

            <Form
                columns={2}
                values={cobro}
                onChange={onChange}
                onValidate={onValidate}
                formSubmitted={submitted}
            >
                <Field label="Fecha de Inicio" field="fechaInicio" render={FormCalendar} required={true} />

                <Field label="Número de Exhibiciones" field="exhibiciones" required={true}
                    render={({ onParentChange, parent, ...props }) => (
                        <FormInputNumber
                            {...props}
                            onChange={(exhibiciones) =>
                                onParentChange({
                                    exhibiciones,
                                    parcialidad: parent?.costo / exhibiciones
                                })
                            }
                        />
                    )}
                />

                <Field label="Costo" field="costo" disabled={true} render={FormInputNumber} />

                <Field label="Saldo" field="saldo" disabled={true} render={FormInputNumber} />

                <Field label="Descuento" field="descuento" required={true}
                    render={({ onParentChange, parent, ...props }) => (
                        <FormInputNumber
                            {...props}
                            onChange={(descuento) =>
                                onParentChange({
                                    descuento,
                                    saldo: parent?.saldoAnterior - descuento,
                                    parcialidad: (parent?.saldoAnterior - descuento) / parent?.exhibiciones
                                })
                            }
                        />
                    )}
                />

                <Field label="Parcialidad" field="parcialidad" disabled={true} render={FormInputNumber} />

                <Field label="Comentarios" field="comentarios" required={true}
                    render={FormTextArea} cols={2} rows={5} maxLength={800}
                />
            </Form>
        </Dialog>
    );
};

export default Cobro;
